import React from "react";
import { Card } from "../../../../CommonElements/Hajj/Card";
import { useTranslation } from "react-i18next";
import { STACK_4 } from "./PilgrimDetails";
import { LabelValue } from "@Component/Value";
import { Tag } from "antd";

export const Incidents = ({ isLoading }) => {
  const { t } = useTranslation();

  // Mock data - replace with actual props/data
  const props = {};

  const { incident_1, incident_date_1, incident_2, incident_date_2 } = props;

  const VerticalLabelValue = (props) => {
    return <LabelValue loading={isLoading} direction="vertical" {...props} />;
  };

  return (
    <Card header={<span className="H5">{t("INCIDENTS")}</span>}>
      <STACK_4>
        <VerticalLabelValue
          label={t("INCIDENT")}
          value={incident_1}
          renderValue={(value) => {
            return (
              <Tag color={!!value ? "red" : "green"}>
                {value ? value : t("لا يوجد واقعات")}
              </Tag>
            );
          }}
        />
        <VerticalLabelValue
          label={t("INCIDENT_DATE")}
          value={incident_date_1 || "-"}
        />
        <VerticalLabelValue label={t("INCIDENT")} value={incident_2 || "-"} />
        <VerticalLabelValue
          label={t("INCIDENT_DATE")}
          value={incident_date_2 || "-"}
        />
      </STACK_4>
    </Card>
  );
};
